export enum ExperienceType {
  Clinic = 'clinic',
  Ambulant = 'ambulantCare',
  NursingHome = 'nursingHome',
  IntensiveAmbulant = 'intensiveAmbulantCare',
  Other = 'other',
}
